import { conditions } from "helpers";
import IMAGES from "images";
import { ConditionName, ICommentDefaultMessages } from "interfaces";
import Image from "next/image";
import { MouseEvent, memo, useEffect, useRef, useState } from "react";
import { shallowEqual } from "react-redux";
import { handleSubmitDefaultMessageComment, useAppSelector } from "redux-share";

const DefaultMessages = () => {
    const commentContainerRef = useRef<any>();

    const { commentDefaultMessages } = useAppSelector(({ comments: { commentDefaultMessages } }) => ({ commentDefaultMessages }), shallowEqual);

    const [scrollPosition, setScrollPosition] = useState<number>(0);
    const [showLeftScrollIcon, setShowLeftScrollIcon] = useState<boolean>(false);
    const [showRightScrollIcon, setShowRightScrollIcon] = useState<boolean>(false);

    const handleClickPrev = (event: MouseEvent<HTMLParagraphElement>) => {
        event.stopPropagation();
        const newScrollPosition = scrollPosition + commentContainerRef.current.clientWidth;
        if (commentContainerRef.current.scrollLeft >= 0) {
            setShowRightScrollIcon(false);
            setShowLeftScrollIcon(true);
        } else {
            setScrollPosition(newScrollPosition);
            commentContainerRef.current.scrollLeft = newScrollPosition;
            setShowRightScrollIcon(true);
            setShowLeftScrollIcon(true);
        }
    };

    const handleClickNext = (event: MouseEvent<HTMLParagraphElement>) => {
        event.stopPropagation();
        const newScrollPosition = scrollPosition - commentContainerRef.current.clientWidth;
        if (commentContainerRef.current.clientWidth + Math.abs(commentContainerRef.current.scrollLeft) >= commentContainerRef.current.scrollWidth - 1)
            setShowLeftScrollIcon(false);
        else {
            setScrollPosition(newScrollPosition);
            commentContainerRef.current.scrollLeft = newScrollPosition;
            setShowRightScrollIcon(true);
        }
    };

    useEffect(() => {
        if (commentContainerRef.current.scrollWidth > commentContainerRef.current.clientWidth) setShowLeftScrollIcon(true);
        else {
            setShowLeftScrollIcon(false);
            setShowRightScrollIcon(false);
        }
    }, [commentDefaultMessages.length]);

    return (
        <div className={`pl-relative ${conditions(ConditionName.isComplexPortrait) ? "pl-order-3" : "pl-order-1"} pl-w-full`}>
            <div className="pl-group pl-flex pl-items-center pl-gap-2 pl-overflow-auto no-scrollbar" ref={commentContainerRef}>
                {commentDefaultMessages.map((item: ICommentDefaultMessages) => (
                    <div
                        key={item.id}
                        className="pl-flex pl-items-center pl-gap-2 pl-bg-gray-highLight dark:pl-bg-z-gray-500 pl-rounded-[16px] pl-px-4 pl-py-1 pl-cursor-pointer"
                        onClick={() => handleSubmitDefaultMessageComment(item.id)}
                    >
                        <p className="pl-text-[12px] pl-font-normal pl-text-gray-800 dark:pl-text-white pl-whitespace-nowrap">{item.text}</p>
                    </div>
                ))}
                {!conditions(ConditionName.isTouchScreen) && (
                    <>
                        <div
                            className={`pl-absolute pl-cursor-pointer pl-right-0 pl-top-1 ${
                                !showRightScrollIcon && "pl-opacity-0 pl-pointer-events-none"
                            }`}
                        >
                            <Image
                                src={conditions(ConditionName.isDarkMode) ? IMAGES.leftArrow : IMAGES.lightLeftArrow}
                                width={15}
                                height={15}
                                alt="left-arrow"
                                onClick={handleClickPrev}
                                onDoubleClick={(event: any) => event.stopPropagation()}
                            />
                        </div>
                        <div
                            className={`pl-absolute pl-cursor-pointer pl-left-0 pl-top-1 ${
                                !showLeftScrollIcon && "pl-opacity-0 pl-pointer-events-none"
                            }`}
                        >
                            <Image
                                src={conditions(ConditionName.isDarkMode) ? IMAGES.rightArrow : IMAGES.lightRightArrow}
                                width={15}
                                height={15}
                                alt="right-arrow"
                                onClick={handleClickNext}
                                onDoubleClick={(event: any) => event.stopPropagation()}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default memo(DefaultMessages);
